import { useEffect, useState } from 'react';

const SCROLL_TOP_THRESHOLD = 50;

/**
 * Shared by the floating chat and feedback launchers so both stop covering
 * page content once the user scrolls past the top of the page.
 */
export const useHideOnScroll = (alwaysDisplay?: boolean) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (alwaysDisplay) {
      setIsVisible(true);
      return;
    }

    const handleScroll = () => {
      setIsVisible(window.scrollY < SCROLL_TOP_THRESHOLD);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [alwaysDisplay]);

  return isVisible;
};
